import styled, { css, keyframes } from 'styled-components';
import { Button, Label } from '../../../Components/uielements';
import { key, palette } from 'styled-theme';

export const StyledContainer = styled.div`
  display: grid;
  gap: ${key('sizes.gap.medium', '20px')};
  margin-top: 20px;
`;

export const HeaderTitle = styled(Label)`
  font-family: Space Grotesk Regular;
  font-size: ${key('sizes.vxxlFont.normal', '20px')} !important;
  color: ${palette('text', 4)};
  font-weight: bold;
  text-transform: uppercase;
`;

export const TableCell = styled.p`
  text-transform: capitalize;
`;
export const TableCellEmail = styled.p``;

export const TableWrapper = styled.div``;

export const IconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  margin-left: 5px;
  ${(props) =>
    props.color === 'success' &&
    css`
      color: ${palette('success', 0)};
    `}
`;

export const OutlineButton = styled(Button)`
  background: transparent !important;
  border: 1.5px solid ${palette('gray', 0)};
  background: ${palette('background', 1)};
  color: ${palette('text', 1)} !important;
  &:hover {
    background: ${palette('background', 2)} !important;
    color: ${palette('text', 0)} !important;
    border: none !important;
  }
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 400px;
`;
export const ErrorModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  max-width: 400px;
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  max-width: fit-content;
  justify-self: center;
`;

export const DeleteMessage = styled(Label)``;
export const ModalGap = styled.div`
  display: grid;
  gap: 28px;
`;

export const CompanyContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const SwitchButtonWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 5px;
`;
export const SwitcherLabel = styled(Label)`
  font-family: Space Grotesk Regular;
  font-size: 14px !important;
  color: ${palette('text', 1)};
  cursor: pointer;
`;

// custom html select dropdown css

// export const StyledSelect = styled.select`
//   padding: 10px 10px 10px 8px;
//   font-size: 14px;
//   border: none;
//   border-bottom: 1px solid ${palette('gray', 3)};
//   outline: none;
//   cursor: pointer;
//   width: 100%;
//   font-family: Space Grotesk Regular;
//   background-color: ${palette('background', 0)} !important;
//   color: #fff;
//   &:hover {
//     border-color: ${palette('background', 2)};
//   }
// `;

export const StyledSelect = styled.select`
  padding: 10px 36px 10px 8px; /* space for arrow */
  font-size: 14px;
  border: none;
  border-bottom: 1px solid ${palette('gray', 3)};
  outline: none;
  cursor: pointer;
  width: 100%;
  font-family: 'Space Grotesk Regular';

  background-color: ${palette('background', 0)} !important;
  color: #fff !important;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* ▼ Custom arrow */
  background-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'>\
    <path d='M1 1l5 5 5-5' stroke='white' stroke-width='2' fill='none' stroke-linecap='round'/>\
  </svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px 8px;

  &:hover {
    border-color: ${palette('background', 2)};
  }

  &:focus {
    outline: none;
  }

  option {
    background-color: ${palette('background', 0)} !important;
    color: #fff !important;
  }
`;

export const StyledOption = styled.option`
  border-radius: 5px;
  background-color: ${palette('background', 0)} !important;
`;

export const StyledSelectWrapper = styled.div`
  position: relative;
`;
export const StyledSelectLabel = styled(Label)`
  position: absolute;
  left: 12px;
  top: -12px;
  font-size: 14px;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

// custom checkbox css

export const CheckBox = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;

  ${({ isRed }) =>
    isRed &&
    css`
      &:checked::before {
        content: '✔';
        /* color: #7aeaa7; */
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 80%;
        font-size: 1em;
      }
    `}
`;

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

export const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${palette('background', 0)};
  backdrop-filter: blur(4px);
  z-index: 9999;
  animation: ${fadeInOut} 0.3s ease-in-out;
`;

export const LoadingText = styled.div`
  color: #ffffff;
  font-family: 'Space Grotesk Regular', sans-serif;
  font-size: 18px;
  font-weight: 400;
  animation: ${pulse} 1s ease-in-out infinite;
  text-align: center;
`;
